<template>    
    <v-card class="mx-1 my-2">
       <v-card-title>
           <v-flex xs12>               
                <h4 class="headline ma-0 grey--text text--darken-2"> {{ mk.name }} </h4>                 
           </v-flex>
       </v-card-title>
       <v-container grid-list-xs class="px-2">
           <v-layout row wrap>
               <v-flex xs12 md6 v-for="(logo,i) in mk.logos" v-bind:key="i + 'lg'">
                    <v-card-media
                        class="ma-2"
                        v-bind:src="markenlogo(logo.dateiserverpfad)"
                        height="90px" 
                        width="150px" 
                        contain
                        >
                    
                    </v-card-media>
                </v-flex> 
               
                <v-flex xs12 md6 v-for="(firma,b) in mk.firmen" v-bind:key="b + 'fa'">                
                        
                    <p><strong>{{ firma.name }} </strong></p>
                    <v-flex xs12 v-for="(adresse,c) in firma.adressen" v-bind:key="c + 'ad'">
                        <p> 
                            {{ adresse.strasse }} <br />
                            {{ adresse.plz }} {{ adresse.ort }}
                        </p>
                    </v-flex>      
                </v-flex>            
                
           </v-layout>
        </v-container>
        <v-card-actions class="grey darken-3 mt-2 pa-0">
                <v-spacer></v-spacer>
                
                    <v-btn icon v-on:click="gotoEdit(mk.id)">
                        <v-icon class="grey--text text--darken-1">build</v-icon>
                    </v-btn>
               
                    <v-btn icon>
                        <v-icon class="grey--text text--darken-1">visibility</v-icon>
                    </v-btn>
                
                    <v-btn icon v-on:click="commitDelete">
                        <v-icon class="grey--text text--darken-1">delete</v-icon>
                    </v-btn>
                
              </v-card-actions>
        <delete-modal v-bind:showDialog.sync="showDialog" v-on:committed="toDestroy"></delete-modal>
    </v-card>
</template>

<script>
import deleteModal from '../shared/deleteModal.vue'
export default {
    props: [
        'mk'
    ],
    data() {
        return {
           markenlogos: [], 
           showDialog: false,
           deleteCommited:false
        };
    },
    components: {
        'delete-modal': deleteModal,
    },    
    computed: {
        basePath: function() {
              return this.$axios.defaults.baseURL
          },   
         
    },
    methods: {
        markenlogo: function(path) {
            return this.basePath + 'storage/logos/' + path;
        },
        toDestroy: function(s) {                
                
                this.deleteCommited = s
                if(this.deleteCommited==false) {
                    return
                }                
                this.$store.dispatch('setPreFilteredMarken',[])
                this.$store.dispatch('setPreFilteredFirmen',[])
                this.$emit("toDestroy");
            
        },
        commitDelete: function() {
            this.showDialog=true                       
        },
        gotoEdit: function(id) {
            this.$store.dispatch('setMarke', id).then((response)=>{
                    this.$router.push('/marken/' + id + '/edit')   
            })
        }
        
    },    
   
}
    
</script>

<style>
        

</style>


// WEBPACK FOOTER //
// singleMarken.vue?39189fde